import React, { Component } from 'react'
import { connect } from 'react-redux';
import { getInterval } from '../components/Pitch/gameJson'
import { delay } from './Animations/helper'

class TextControl extends Component {

    constructor(props) {
        super(props);
        this.currentTextMessage = "";
        this.currentTextOwner = 0;
        this.Settings = window.TextSettings;
    }

    componentWillReceiveProps(nextProps){
      if(this.props.currentEvent != nextProps.currentEvent) {
        let time = 0;
        if(Math.abs(this.props.currentEvent - nextProps.currentEvent) > 1) {
          time = 5;
        }
        else {
          time = this.readTime(nextProps.currentEvent);
        }
        this.updateAfter(time);
      }
    }

    updateAfter(time) {
      delay(time*this.props.gameSpeed).then(() => this.forceUpdate())
    }

    readTime(eventNum) {
      return getInterval(eventNum-1);
    }

    shouldComponentUpdate(nextProps, nextState) {
      return false;
    }

    readCurrentEvent(){
      if(this.props.currentEvent == 0)
        return {message: "", owmer: 0};

      return window.Json.game[this.props.currentEvent-1];
    }

    getText(currentEvent) {
      if(currentEvent.messages != null && currentEvent.messages.length > 0) {
        let res = '';
        for (var index = 0; index < currentEvent.messages.length; index++) {
          var message = currentEvent.messages[index];
          if(message.mes != null && message.mes != '') {
            res = res + message.mes+ " ";
          }
        }

        return res.replace(/\[([0-9]{1,})\]/g, "");
      }

      return null;
    }

    getOwner(currentEvent) {
      if(currentEvent.messages != null && currentEvent.messages.length > 0) {
        if(currentEvent.messages[0].owner != null) {
          return  currentEvent.messages[0].owner;
        }
      }

      return this.currentTextOwner;
    }

    getClass(currentEvent) {
      if(currentEvent.G != null && !this.props.replay && this.Settings.UseTeamColors) {
        if(currentEvent.G.team === 1)
          return "goal_animation home";
        else
          return "goal_animation away";
      }
      return "";
    }

    render() {
        var currentEvent = this.readCurrentEvent();
        var textMessage = this.getText(currentEvent);
        var owner = this.getOwner(currentEvent);
        var style = {};

        if(this.Settings.UseTeamColors)
          switch (owner) {
            case 0:
              /*style = {
                background: 'white',
                color: 'black'
              };*/
              break;
            case 1:
              style = {
                background: this.props.homeTeam.Back,
                color: this.props.homeTeam.Color
              };
              break;
            case 2:
              style = {
                background: this.props.awayTeam.Back,
                color: this.props.awayTeam.Color
              };
              break;
          }

        if(textMessage == null || textMessage == "" || textMessage.trim() == ""){
          textMessage = this.currentTextMessage;
        } else {
          this.currentTextMessage = textMessage.trim();
          if(this.currentTextMessage.length > 260) {
            this.currentTextMessage = this.currentTextMessage.substring(0, 260) + '...'
          }
        }

        this.currentTextOwner = owner;

        return (<div className="row">
                  <div className="col-md-12">
                    <div id="textControl" style={style}>
                    <div className={this.getClass(currentEvent)}>{this.currentTextMessage}</div>
                    </div>
                  </div>
                </div>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        currentEvent: state.currentEvent,
        gameSpeed: state.gameSpeed,
        homeTeam: state.HomeTeam,
        awayTeam: state.AwayTeam,
        replay: state.replay != null
    };
}

export default connect(mapStateToProps)(TextControl)



/** WEBPACK FOOTER **
 ** ./src/components/TextControl.js
 **/